export enum OpportunityStatuses {
    WON = 'Won',
    IN_PROGRESS = 'In progress',
    LOST = 'Lost',
}
